import{__require as r}from"./factoryWithThrowingShims.js";r()();
//# sourceMappingURL=index.js.map
